/**
 * Created by Ivan on 24.02.2026
 */

// eslint-disable-next-line
let IslandDecorationConfig = {};

IslandDecorationConfig.stages = [{
    name: "stage1",
    rewards: {
        mission: { amount: 300, missionType: Mission.TYPE_ISLAND_DECORATION },
        energy: 50,
        stickers2BrownPack: 1
    },
    items: [{
        name: "item1",
        price: 60
    }, {
        name: "item2",
        price: 80
    }, {
        name: "item3",
        price: 140
    }]
}, {
    name: "stage2",
    rewards: {
        mission: { amount: 450, missionType: Mission.TYPE_ISLAND_DECORATION },
        unit: [
            { code: "sacks", stage: 2, amount: 1 }
        ],
        stickers2BrownPack: 1
    },
    items: [{
        name: "item4",
        price: 110
    }, {
        name: "item5",
        price: 170
    }, {
        name: "item6",
        price: 280
    }]
}, {
    name: "stage3",
    rewards: {
        mission: { amount: 550, missionType: Mission.TYPE_ISLAND_DECORATION },
        energy: 100,
        stickers2GreenPack: 1
    },
    items: [{
        name: "item7",
        price: 200
    }, {
        name: "item8",
        price: 300
    }, {
        name: "item9",
        price: 500
    }]
}, {
    name: "stage4",
    rewards: {
        mission: { amount: 650, missionType: Mission.TYPE_ISLAND_DECORATION },
        unit: [
            { code: "worker", stage: 4, amount: 1 }
        ],
        stickers2GreenPack: 1
    },
    items: [{
        name: "item10",
        price: 510
    }, {
        name: "item11",
        price: 770
    }, {
        name: "item12",
        price: 1280
    }]
}, {
    name: "stage5",
    rewards: {
        mission: { amount: 800, missionType: Mission.TYPE_ISLAND_DECORATION },
        energy: 150,
        stickers2BluePack: 1
    },
    items: [{
        name: "item13",
        price: 910
    }, {
        name: "item14",
        price: 1360
    }, {
        name: "item15",
        price: 2270
    }]
}, {
    name: "stage6",
    rewards: {
        mission: { amount: 1050, missionType: Mission.TYPE_ISLAND_DECORATION },
        unit: [
            { code: "herochest", stage: 2, amount: 1 }
        ],
        stickers2BluePack: 1
    },
    items: [{
        name: "item16",
        price: 1650
    }, {
        name: "item17",
        price: 2470
    }, {
        name: "item18",
        price: 4120
    }]
}, {
    name: "stage7",
    rewards: {
        energy: 250,
        stickers2VioletPack: 1
    },
    items: [{
        name: "item19",
        price: 2160
    }, {
        name: "item20",
        price: 3250
    }, {
        name: "item21",
        price: 5410
    }]
}];

IslandDecorationConfig.stages.forEach((stage, stageId) => {
    stage.id = stageId;

    stage.items.forEach((item, itemId) => {
        item.id = itemId;
        item.stage = stageId;
    });
});

IslandDecorationConfig.getPeriod = function () {
    const event = cleverapps.eventManager.getFeatureEvent("island_decoration");
    return event && event.options && event.options.period;
};

RewardsConfig.IslandDecorationReward = {
    soft: 1000,
    unit: [
        { code: "herochest", stage: 2, amount: 1 },
        { code: "worker", stage: 4, amount: 1 },
        { code: "crystal", stage: 3, amount: 1 }
    ],
    stickers2RedPack: 1
};
